import React from "react";
import styles from "./index.module.scss";
import Noif from "../../../../shared/assets/icons/notif.svg";
import { Button } from "../../../../shared/ui/Button";
import { IOffer } from "../../../../shared/store/payment/types";

interface IChangeSumAlert {
  offer: IOffer;
  onClick: () => void;
}

export const ChangeSumAlert: React.FC<IChangeSumAlert> = ({
  offer,
  onClick,
}) => {
  return (
    <div className={styles.alert}>
      <img src={Noif} alt="" className={styles.icon} />
      <h2 className={styles.title}>Внимание</h2>
      <div className={styles.description}>
        {`Сумма на оплату изменилась c ${offer.startAmountFiat} руб. до ${offer.amountFiat} руб.`}
      </div>
      <Button content="Принять" className={styles.btn} onClick={onClick}/>
    </div>
  );
};
